import { create } from "zustand";
import { UpdateFn, Updater } from "../../types";

interface State {
  component: React.ReactNode;
}

interface Action {
  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>) => void;
  setComponent: UpdateFn<React.ReactNode>;
}

const useSidePanelPageStore = create<State & Action>((set, get) => ({
  component: null,

  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>): void => {
    if (typeof updater === "function") {
      set((state) => ({ [key]: updater(state[key]) }));
    } else {
      set({ [key]: updater });
    }
  },

  setComponent: (component) => {
    get().setter("component", component);
  },
}));

export default useSidePanelPageStore;
